import type { CareManagementSkill } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'

import { useQuery } from 'react-query'
import { SKILLS_QUERY_KEY, SKILLS_URL } from './queryConstants'

type Skill = {
  id: string
  name: string
}

type UseUserSkills = {
  allSkills: Skill[]
  isLoading: boolean
}

const useUserSkills = (): UseUserSkills => {
  const { isLoading: isLoadingSkills, data: allSkillsData } = useQuery(
    [SKILLS_QUERY_KEY],
    () =>
      getJSON({
        url: SKILLS_URL,
        isRota: true
      })
  )

  return {
    allSkills: allSkillsData
      ? (allSkillsData as CareManagementSkill[]).map((skillObj) => ({
          id: skillObj?.skill?.id,
          name: skillObj?.skill?.name
        }))
      : [],
    isLoading: isLoadingSkills
  }
}

export default useUserSkills
